






import { Component, Vue, Prop } from 'vue-property-decorator';
import { Actions, Mutations, ViewModes } from '@/ts/store/Constants';
import ConversationData from '@/ts/ConversationData';

@Component({})

export default class HococoAddButton extends Vue {
    constructor() {
        super();
    }

    public triggerAction() {
        this.$store.commit(this.$store.getters['Viewport/getAddButtonAction'], true);
    }
}
